import { rest } from 'msw'

let refreshRequestCount = 0
let refreshFailureCountBeforeSuccess = 1

export const setRefreshFailureCountBeforeSuccess = (count) => {
  refreshFailureCountBeforeSuccess = Math.max(0, Number(count) || 0)
}

export const resetRefreshMockState = () => {
  refreshRequestCount = 0
}

export default [
  /**
   * user announcements
   */
  rest.get('/swc-api/master/announcement-user', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json([
        {
          id: 1,
          announcement_master_id: 1,
          announcement_time: '2026-07-03T09:00:00+09:00',
          announcement_title: 'mock お知らせ',
          announcement_level: 'normal',
          hide: true,
          confirm: false
        }
      ])
    )
  }),

  rest.post('/swc-api/master/announcement-user', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        detail: 'mock announcement user updated'
      })
    )
  }),

  rest.get('/swc-api/master/announcement-master/:id', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        id: Number(req.params.id),
        title: 'mock お知らせ',
        rich_text_message: 'mock お知らせ本文です。',
        announcement_time: '2026-07-03T09:00:00+09:00'
      })
    )
  }),

  /**
   * login announcements
   */
  rest.get('/swc-api/master/announcement-login', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),

  /**
   * external login
   */
  rest.post('/swc-api/login/external/', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        detail: 'mock login external success'
      })
    )
  }),

  /**
   * MFA login
   */
  rest.get('/swc-api/login/mfa/', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        token: {
          access_token: 'dummy',
          refresh_token: 'dummy'
        }
      })
    )
  }),

  /**
   * refresh token
   */
   rest.post('/swc-api/token/refresh/', (req, res, ctx) => {
    refreshRequestCount += 1

    if (refreshRequestCount <= refreshFailureCountBeforeSuccess) {
      return res(
        ctx.status(502),
        ctx.json({
          detail: 'mock bad gateway'
        })
      )
    }

    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json({
        "access": "dummy",
        "refresh": "dummy"
      })
    )
  }),
]
